(() => {
  const normalizeLabel = (name, values, title) => {
    let key = (name || '').trim().toLowerCase();
    if (key === '颜色') key = 'color';
    if (key === '纯度') key = 'purity';
    if (key === '尺码' || key === '尺寸') key = 'size';
    const joined = (values || '').toLowerCase();
    const product = (title || '').toLowerCase();
    if (key === 'purity') {
      if (/inch|cm/.test(joined)) {
        if (product.includes('bracelet') || product.includes('bangle')) return 'Bracelet Length';
        if (product.includes('necklace') || product.includes('chain')) return 'Chain Length';
        return 'Length';
      }
      if (/925|silver|gold/.test(joined)) return 'Metal';
      if (/inch|cm|mm/.test(joined)) return 'Length';
      if (/carat|\bct\b|stone|moissanite|emerald|ruby|sapphire|paraiba/.test(joined)) return 'Stone Option';
      if (/pendant|earring|chain/.test(joined)) return 'Style';
      return 'Option';
    }
    if (key === 'size' || key === 'ring size' || key === 'us ring size') {
      if (product.includes('ring')) return 'Ring Size';
      if (product.includes('bracelet') || product.includes('bangle')) return 'Bracelet Length';
      if (product.includes('necklace') || product.includes('chain')) return 'Chain Length';
      return 'Size';
    }
    if (key === 'color' || key === 'product color') {
      if (product.includes('initial') && /^[a-z\s]+$/i.test(joined)) return 'Letter';
      if (/white gold|yellow gold|rose gold|gold plated|silver tone/.test(joined) && !/carat|stone|emerald|ruby|sapphire|moissanite/.test(joined)) return 'Finish';
      if (/blue|green|pink|red|champagne|emerald|ruby|sapphire|paraiba/.test(joined)) return 'Stone Option';
      return 'Style';
    }
    return name ? name.charAt(0).toUpperCase() + name.slice(1) : 'Option';
  };

  const normalizeValue = (raw) => {
    let value = (raw || '').trim();
    if (/port code/i.test(value)) value = value.split(/[(/]/)[0].trim();
    value = value
      .replace(/mozzarella diamond/gi, 'Moissanite')
      .replace(/full mozzarella/gi, 'Moissanite')
      .replace(/full mozambican/gi, 'Moissanite')
      .replace(/mozambican diamond/gi, 'Moissanite')
      .replace(/full mozambique/gi, 'Moissanite')
      .replace(/cultivating\s+/gi, 'Lab-Grown ')
      .replace(/cultivated\s+/gi, 'Lab-Grown ')
      .replace(/cultivate\s+/gi, 'Lab-Grown ')
      .replace(/nurturing\s+/gi, 'Lab-Grown ')
      .replace(/nurture\s+/gi, 'Lab-Grown ')
      .replace(/hongbao/gi, 'Ruby')
      .replace(/莫桑石/g, 'Moissanite')
      .replace(/925银培育蓝宝手链/g, 'Lab-Grown Blue Sapphire Bracelet in 925 Sterling Silver')
      .replace(/培育祖母绿（吊坠不含链）/g, 'Lab-Grown Emerald Pendant Only')
      .replace(/培育祖母绿（吊坠含链）/g, 'Lab-Grown Emerald Pendant with Chain')
      .replace(/925银-长度223mm/g, '925 Sterling Silver · 223 mm Length')
      .replace(/925银/g, '925 Sterling Silver')
      .replace(/白金色（1\.5\+0\.5ct）/g, 'White Gold Tone (1.5 + 0.5 ct)')
      .replace(/黄金色/g, 'Gold Tone')
      .replace(/38\+7cm延长链/g, '38 cm + 7 cm Extender')
      .replace(/Papalacha/gi, 'Padparadscha')
      .replace(/S925\s*silver/gi, '925 Sterling Silver')
      .replace(/925\s*silver/gi, '925 Sterling Silver')
      .replace(/^US\s*Ring\s*Size\s*(?:No\.\s*)?/i, 'US ')
      .replace(/American Code No\.\s*/gi, 'US ')
      .replace(/Beauty Code No\.\s*/gi, 'US ')
      .replace(/US\s*Code\s*No\.\s*/gi, 'US ')
      .replace(/US\s*code\s*/gi, 'US ')
      .replace(/^No\.\s*/i, 'US ')
      .replace(/US(\d)/g, 'US $1')
      .replace(/#$/g, '')
      .replace(/Seven inches\.?/gi, '7 inches')
      .replace(/\s{2,}/g, ' ')
      .trim();
    return value;
  };

  const enhance = (root = document) => {
    root.querySelectorAll('.bls__template-product fieldset[data-lumingem-option-name]').forEach((fieldset) => {
      const rawName = fieldset.dataset.lumingemOptionName || '';
      const productTitle = fieldset.dataset.lumingemProductTitle || '';
      const values = [...fieldset.querySelectorAll('.bls__option-swatch[data-value]')].map((item) => item.dataset.value || '').join(' ');
      const label = fieldset.querySelector('.swatch-attribute-label');
      const normalizedLabel = normalizeLabel(rawName, values, productTitle);
      fieldset.classList.toggle('lumingem-ring-size', normalizedLabel === 'Ring Size');
      if (label) label.textContent = normalizedLabel + ':';
      fieldset.querySelectorAll('.bls__option-swatch[data-value]').forEach((item) => {
        let clean = normalizeValue(item.dataset.value || '');
        if (normalizedLabel === 'Ring Size' && window.matchMedia('(max-width: 767px)').matches) {
          clean = clean.replace(/^US\s+/i, '');
        }
        item.querySelectorAll('label, .bls_swatche-item, .bls_tooltip-content').forEach((node) => {
          if (node.children.length === 0) node.textContent = clean;
        });
      });
      fieldset.querySelectorAll('.bls__color-dropdown-value').forEach((node) => {
        node.textContent = normalizeValue(node.textContent);
      });
    });
  };

  const start = () => {
    enhance();
    const productRoot = document.querySelector('.bls__template-product');
    if (!productRoot) return;
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData' && mutation.target.parentElement?.matches('.bls__color-dropdown-value')) {
          const node = mutation.target.parentElement;
          const clean = normalizeValue(node.textContent);
          if (node.textContent !== clean) node.textContent = clean;
        }
      });
    }).observe(productRoot, { subtree: true, characterData: true, childList: true });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, { once: true }) : start();
})();
